export const createEvent = (props) => ({
  preventDefault: () => {},
  target: { ...props },
})
